import { render, staticRenderFns } from "./RollingView.vue?vue&type=template&id=0c5d67e0&scoped=true"
import script from "./RollingView.vue?vue&type=script&lang=js"
export * from "./RollingView.vue?vue&type=script&lang=js"
import style0 from "./RollingView.vue?vue&type=style&index=0&id=0c5d67e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5d67e0",
  null
  
)

export default component.exports